import clsx from "clsx";
import { Accordion, Col, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { React, useState } from "react";
import _ from "lodash";
import * as marginSelectors from "../../../../selectors/margin";
import CustomEmptyFont from "../../../../components/CustomEmptyFont";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import EmptyItemView from "../../../../components/EmptyItemView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import Helper from "../../../../utils/Helper";
import Constants from "../../../../constants";
const dataArrayListing = ["0", "1", "2", "3", "4", "5"];

function MarginStatementBodySection({ data, loading }) {
  const summary = _.get(data, ["summary"], null);
  const [transactionDateOrderBy, setTransactionDateOrderBy] = useState(false);
  const [stockNameOrderBy, setStockNameOrderBy] = useState(null);
  const [shareHoldingStockNameOrderBy, setShareHoldingStockNameOrderBy] = useState(null);
  const [corporateActionStockNameOrderBy, setCorporateActionStockNameOrderBy] = useState(null);
  
  const shareItems = marginSelectors.getSummaryDetailItems(
    marginSelectors.getMarginSummaryShares(summary),
  );

  const shareItemTotalMarginAmount =
    marginSelectors.getSummaryDetailTotalMarginAmountFullText(
      marginSelectors.getMarginSummarySharesSummary(summary),
    );
  const shareItemTotalMarketValue =
    marginSelectors.getSummaryDetailTotalMarketValueFullText(
      marginSelectors.getMarginSummarySharesSummary(summary),
    );
  const tradeNoDueItems = marginSelectors.getSummaryDetailItems(
    marginSelectors.getMarginSummaryTradeNoDue(summary),
  );
  const tradeNoDueTotalQuantity = marginSelectors.getSummaryDetailTotalQuantity(
    marginSelectors.getMarginSummaryTradeNoDueSummary(summary),
  );

  const tradeNoDueMarketValue =
    marginSelectors.getSummaryDetailTotalMarketValueFullText(
      marginSelectors.getMarginSummaryTradeNoDueSummary(summary),
    );
  const tradeNoDueMarginValue =
    marginSelectors.getSummaryDetailTotalMarginAmountFullText(
      marginSelectors.getMarginSummaryTradeNoDueSummary(summary),
    );

  const corporateActionItems = marginSelectors.getSummaryDetailItems(
    marginSelectors.getMarginSummaryCorporateAction(summary),
  );
  const corporateActionMarginValue =
    marginSelectors.getSummaryDetailTotalMarginAmountFullText(
      marginSelectors.getMarginSummaryCorporateActionSummary(summary),
    );

  const [activeKey, setActiveKey] = useState(dataArrayListing);
  const handleAccordionClick = (eventKey) => {
    setActiveKey(activeKey === eventKey ? null : eventKey);
  };

  const orderByTradeNoDueItems = Helper.orderByData(
    tradeNoDueItems,
    transactionDateOrderBy,
    stockNameOrderBy,
  );  
  
  const orderByCorporateActionItems = Helper.orderByData(
    corporateActionItems,
    false,
    corporateActionStockNameOrderBy,
  );

  const orderByShareItems = Helper.orderByData(
    shareItems,
    false,
    shareHoldingStockNameOrderBy,
  );

  return (
    <div className={clsx("custom-table-info-container padding-12px")}>
      <Accordion
          activeKey={activeKey}
          onSelect={handleAccordionClick}
          flush
          alwaysOpen
      >
        {/*// ============ Trust Money ============ */}
        <h3 className="margin-statement-table-big-title my-3">
          1. Share Holdings
        </h3>
        <div
            className={"responsive-table-border table-w-1400"}
            style={{overflowY: "auto"}}
        >
          <Table responsive="xxl">
            {!loading && !_.isEmpty(shareItems) ? (
                <thead>
                <tr className={"custom-table-setoff-styled"}>
                  <th style={{width: 280}}>#</th>
                  <th style={{width: 130}}>Stock Code</th>
                  <th style={{width: 140}}>
                    <div
                        className="pointer"
                        onClick={() => {
                          setShareHoldingStockNameOrderBy((prev) => {
                            if (prev === Constants.ORDER_BY_ASC) {
                              return Constants.ORDER_BY_DESC;
                            }
                            if (prev === Constants.ORDER_BY_DESC) {
                              return Constants.ORDER_BY_ASC;
                            }
                            return Constants.ORDER_BY_ASC;
                          });
                        }}
                    >
                      Stock Name
                      <FontAwesomeIcon
                          className="mx-2"
                          icon={faSort}
                      ></FontAwesomeIcon>
                    </div>
                  </th>
                  <th style={{width: 290}}>Quantity</th>
                  <th style={{width: 160}}>Closing Price</th>
                  <th style={{width: 160}}>Market Value</th>
                  <th style={{width: 160}}>Margin Rate</th>
                  <th style={{width: 160}}>Margin Value</th>
                </tr>
                </thead>
            ) : (
                false
            )}
            <tbody>
            {!_.isEmpty(orderByShareItems) && !loading ? (
                _.map(orderByShareItems, (item, index) => {
                  const stockCode =
                      marginSelectors.getSummaryItemStockCode(item);
                  const stockName =
                      marginSelectors.getSummaryItemStockName(item);
                  const quantity =
                      marginSelectors.getSummaryItemQuantity(item);
                  const marketPriceFullText =
                      marginSelectors.getSummaryItemMarketPriceFullText(item);
                  const marketValueFullText =
                      marginSelectors.getSummaryItemMarketValueFullText(item);
                  const marginRateText =
                      marginSelectors.getSummaryItemMarginRateText(item);
                  const marginValueFullText =
                      marginSelectors.getSummaryItemMarginValueFullText(item);

                  return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <CustomEmptyFont variant="span" value={stockCode}/>
                        </td>
                        <td>
                          <CustomEmptyFont variant="span" value={stockName}/>
                        </td>
                        <td>
                          <CustomEmptyFont variant="span" value={quantity}/>
                        </td>
                        <td>
                          <CustomEmptyFont
                              variant="span"
                              value={marketPriceFullText}
                          />
                        </td>
                        <td>
                          <CustomEmptyFont
                              variant="span"
                              value={marketValueFullText}
                          />
                        </td>
                        <td>
                          <CustomEmptyFont
                              variant="span"
                              value={marginRateText}
                          />
                        </td>
                        <td>
                          <CustomEmptyFont
                              variant="span"
                              value={marginValueFullText}
                          />
                        </td>
                      </tr>
                  );
                })
            ) : (
                <tr>
                  <td colSpan={8}>
                    <EmptyItemView extraCss={{height: "100px"}}/>
                    <LoadingOverlay loading={loading}></LoadingOverlay>
                  </td>
                </tr>
            )}
            </tbody>
            {!loading && !_.isEmpty(shareItems) ? (
                <tfoot className="setoff-table-footer custom-table-lightgray-styled">
                <tr>
                  <th colSpan={5} className="text-end">
                    Total:
                  </th>
                  <th>{shareItemTotalMarketValue} </th>
                  <th></th>
                  <th>{shareItemTotalMarginAmount} </th>
                </tr>
                </tfoot>
            ) : (
                false
            )}
          </Table>
        </div>
        {/*// ============ Shares ============ */}
        <div className="margin-statement-margin-container">
          <>
            <h3 className="margin-statement-table-big-title my-3">
              2. Trades Not Due
            </h3>
            <div
                className={"responsive-table-border table-w-1400"}
                style={{maxHeight: "500px"}}
            >
              <Table responsive="xxl">
                {!loading && !_.isEmpty(tradeNoDueItems) ? (
                    <thead>
                    <tr className={"custom-table-setoff-styled"}>
                      <th style={{width: 120}}>
                        <div
                            className="pointer"
                            onClick={() => {
                              setStockNameOrderBy(null);
                              setTransactionDateOrderBy((prev) => {
                                return !prev;
                              });
                            }}
                        >
                          Date
                          <FontAwesomeIcon
                              className="mx-2"
                              icon={faSort}
                          ></FontAwesomeIcon>
                        </div>
                      </th>
                      <th style={{width: 160}}>Reference No</th>
                      <th style={{width: 130}}>Stock Code</th>
                      <th style={{width: 140}}>
                        <div
                            className="pointer"
                            onClick={() => {
                              setTransactionDateOrderBy(false);
                              setStockNameOrderBy((prev) => {
                                if (prev === Constants.ORDER_BY_ASC) {
                                  return Constants.ORDER_BY_DESC;
                                }
                                if (prev === Constants.ORDER_BY_DESC) {
                                  return Constants.ORDER_BY_ASC;
                                }
                                return Constants.ORDER_BY_ASC;
                              });
                            }}
                        >
                          Stock Name
                          <FontAwesomeIcon
                              className="mx-2"
                              icon={faSort}
                          ></FontAwesomeIcon>
                        </div>
                      </th>
                      <th style={{width: 130}}>Quantity</th>
                      <th style={{width: 160}}>Trade Done Price</th>
                      <th style={{width: 160}}>Closing Price</th>
                      <th style={{width: 160}}>Market Value</th>
                      <th style={{width: 160}}>Margin Rate</th>
                      <th style={{width: 160}}>Margin Value</th>
                    </tr>
                    </thead>
                ) : (
                    false
                )}
                <tbody>
                {!_.isEmpty(orderByTradeNoDueItems) && !loading ? (
                    _.map(orderByTradeNoDueItems, (item, index) => {
                      const stockCode =
                          marginSelectors.getSummaryItemStockCode(item);
                      const stockName =
                          marginSelectors.getSummaryItemStockName(item);
                      const quantity =
                          marginSelectors.getSummaryItemQuantity(item);
                      const marketPriceFullText =
                          marginSelectors.getSummaryItemMarketPriceFullText(
                              item,
                          );
                      const transactionDate =
                          marginSelectors.getSummaryItemTransactionDate(item);
                      const marketValueFullText =
                          marginSelectors.getSummaryItemMarketValueFullText(
                              item,
                          );

                      const contractReference =
                          marginSelectors.getSummaryItemContractReference(
                              item,
                          );
                      const purchasePriceFullText =
                          marginSelectors.getSummaryItemPurchasePriceFullText(
                              item,
                          );

                      const marginRateText =
                          marginSelectors.getSummaryItemMarginRateText(item);
                      const marginValueFullText =
                          marginSelectors.getSummaryItemMarginValueFullText(
                              item,
                          );
                      return (
                          <tr key={index}>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={transactionDate}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={contractReference}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={stockCode}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={stockName}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={quantity}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={purchasePriceFullText}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={marketPriceFullText}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={marketValueFullText}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={marginRateText}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={marginValueFullText}
                              />
                            </td>
                          </tr>
                      );
                    })
                ) : (
                    <tr>
                      <td colSpan={10}>
                        <EmptyItemView extraCss={{height: "100px"}}/>
                        <LoadingOverlay loading={loading}></LoadingOverlay>
                      </td>
                    </tr>
                )}
                </tbody>
                {!loading && !_.isEmpty(tradeNoDueItems) ? (
                    <tfoot className="setoff-table-footer custom-table-lightgray-styled">
                    <tr>
                      <th colSpan={4} className={clsx("text-end")}>
                        Total:
                      </th>
                      <th>
                        <CustomEmptyFont
                            variant="span"
                            value={tradeNoDueTotalQuantity}
                        />
                      </th>
                      <th></th>
                      <th></th>
                      <th>
                        <CustomEmptyFont
                            variant="span"
                            value={tradeNoDueMarketValue}
                        />
                      </th>
                      <th></th>
                      <th>
                        <CustomEmptyFont
                            variant="span"
                            value={tradeNoDueMarginValue}
                        />
                      </th>
                    </tr>
                    </tfoot>
                ) : (
                    false
                )}
              </Table>
            </div>
          </>
        </div>
        {/*// ============ Corporate Action ============ */}
        <div className="margin-statement-margin-container">
          <>
            <h3 className="margin-statement-table-big-title my-3">
              3. Corporate Action
            </h3>
            <div
                className={"responsive-table-border table-w-1400"}
                style={{maxHeight: "500px"}}
            >
              <Table responsive="xxl">
                {!loading && !_.isEmpty(corporateActionItems) ? (
                    <thead>
                    <tr className={"custom-table-setoff-styled"}>
                      <th style={{width: 280}}>Entitlement</th>
                      <th style={{width: 130}}>Stock Code</th>
                      <th style={{width: 140}}>
                        <div
                            className="pointer"
                            onClick={() => {
                              setCorporateActionStockNameOrderBy((prev) => {
                                if (prev === Constants.ORDER_BY_ASC) {
                                  return Constants.ORDER_BY_DESC;
                                }
                                if (prev === Constants.ORDER_BY_DESC) {
                                  return Constants.ORDER_BY_ASC;
                                }
                                return Constants.ORDER_BY_ASC;
                              });
                            }}
                        >
                          Stock Name
                          <FontAwesomeIcon
                              className="mx-2"
                              icon={faSort}
                          ></FontAwesomeIcon>
                        </div>
                      </th>
                      <th style={{width: 290}}>Entitled Quantity</th>
                      <th style={{width: 160}}>Closing Price</th>
                      <th style={{width: 160}}>Market Value</th>
                      <th style={{width: 160}}>Margin Rate</th>
                      <th style={{width: 160}}>Margin Value</th>
                    </tr>
                    </thead>
                ) : (
                    false
                )}
                <tbody>
                {!_.isEmpty(orderByCorporateActionItems) && !loading ? (
                    _.map(orderByCorporateActionItems, (item, index) => {
                      const entitlement =
                          marginSelectors.getSummaryItemEntitlement(item);
                      const stockCode =
                          marginSelectors.getSummaryItemStockCode(item);
                      const stockName =
                          marginSelectors.getSummaryItemStockName(item);
                      const quantity =
                          marginSelectors.getSummaryItemQuantity(item);
                      const marketPriceFullText =
                          marginSelectors.getSummaryItemMarketPriceFullText(
                              item,
                          );
                      const marketValueFullText =
                          marginSelectors.getSummaryItemMarketValueFullText(
                              item,
                          );
                      const marginRateText =
                          marginSelectors.getSummaryItemMarginRateText(item);
                      const marginValueFullText =
                          marginSelectors.getSummaryItemMarginValueFullText(
                              item,
                          );

                      return (
                          <tr key={index}>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={entitlement}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={stockCode}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={stockName}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={quantity}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={marketPriceFullText}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={marketValueFullText}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={marginRateText}
                              />
                            </td>
                            <td>
                              <CustomEmptyFont
                                  variant="span"
                                  value={marginValueFullText}
                              />
                            </td>
                          </tr>
                      );
                    })
                ) : (
                    <tr>
                      <td colSpan={10}>
                        <EmptyItemView extraCss={{height: "100px"}}/>
                        <LoadingOverlay loading={loading}></LoadingOverlay>
                      </td>
                    </tr>
                )}
                </tbody>
                {!loading && !_.isEmpty(corporateActionItems) ? (
                    <tfoot className="setoff-table-footer custom-table-lightgray-styled">
                    <tr>
                      <th colSpan={7} className="text-end">
                        Total:
                      </th>
                      <th>{corporateActionMarginValue} </th>
                    </tr>
                    </tfoot>
                ) : (
                    false
                )}
              </Table>
            </div>
          </>
        </div>
      </Accordion>
    </div>
  );
}

export default MarginStatementBodySection;
